import $ from "jquery";
import {
  clearBearerCookie,
  clearSessionStorage,
  testBrowserVersion,
  testJavaScript,
} from "./loginInitFunctions";
import setupHccLogin from "./setupHccLogin";
import "./login.css";

// TODO: use native stuff instead of jquery

// $(document).ready(function () {
testJavaScript();
testBrowserVersion();
clearSessionStorage();
clearBearerCookie();

$("#loginForm input").on("keypress", function (e) {
  if (e.which == 13) {
    //'click' the link button, form will post, Button_Click will fire on back-end
    __doPostBack("cmdSubmit", ""); //the second parameter is required and superfluous, just use blank
    e.preventDefault();
  }
});

$("#cmdSign").on("click", function (e) {
  e.preventDefault();
  // Reload page to generate a value to sign and start autologin with HCC.
  if (console) console.log("Reloading page to get signature challenge");
  location.reload(true);
});

setupHccLogin();
// });
